/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Header from "../../components/layout/header";
import Footer from "../../components/layout/footer";
import { VImage } from "../../style/base.style";
import { breadcrumb_bg_01, breadcrumb_bg_02, breadcrumb_icon } from "../../constants/images";
import { BreadCrumb } from "../../components/common/breadcrumb";
import { FAQComponent } from "../../components/faq";
import { useDictionary } from "../../contexts/dictionary";
const Faq = () => {
  const location = useLocation()
  const {translate} = useDictionary();

  return (
    <>
      <Header />
      <>
        {/* Breadcrumb */}
        <BreadCrumb title={translate("faq_title")} />
        {/* /Breadcrumb */}
        {/* FAQ Section */}
        <section className="faq-inner-page">
          <div className="container">
            <FAQComponent numberOfQuestions={10} columns={2} />
          </div>
        </section>
        {/* /FAQ Section */}
      </>


      <Footer />
    </>
  );
};

export default Faq;
